function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 .333l.234.004c3.574.124 6.433 3.06 6.433 6.663l-.004.234c-.124 3.574-3.06 6.433-6.663 6.433C3.318 13.667.333 10.682.333 7S3.318.333 7 .333zm0 1.334C4.054 1.667 1.667 4.054 1.667 7S4.054 12.333 7 12.333l.22-.004c2.843-.115 5.113-2.457 5.113-5.329l-.004-.22C12.214 3.937 9.872 1.667 7 1.667zM5.76 4.54c.254-.267.676-.277.943-.023.267.254.278.676.024.943l-.834.873h3.774c.368 0 .666.299.666.667 0 .368-.298.667-.666.667H5.94l.867.853c.263.265.261.687 0 .947-.266.263-.688.261-.947 0l-2-2c-.06-.062-.108-.134-.14-.214l-.029-.082c-.015-.055-.024-.113-.024-.171l.013-.06c.003-.064.017-.127.04-.187l.032-.066.041-.06.029-.045.031-.042z"
});

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.4f779d9a.svg";
export { ForwardRef as ReactComponent };